import contractOverview from './contract-overview';
import contractTerms from './contract-terms';
import detailPanel from './detail-panel';
import list from './list';
import searchForm from './search-form';

export default {
  searchForm,
  list,
  detailPanel,
  contractOverview,
  contractTerms,
  costCalculator: 'listing-search-cost-calculator',
};
